module.exports = __webpack_public_path__ + "static/img/support_1.d9918de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hrdonates/support_1.png
// module id = Q82C
// module chunks = 0